import React from 'react'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import TxtIntro1 from '../../sharedcomponents/TextIntro/TxtIntro1'
import Section1 from '../../components/about/Section1'
import ParallaxOtherPages from '../../sharedcomponents/parallaxOtherPages/parallaxOtherPages.js';
import {imgHome6} from '../../sharedcomponents/ImageScope';
import Footer from '../../sharedcomponents/footer/Index.js';

import './index.css'
export default function About(){
  return(
    <>
      <div style={{maxWidth:'1920px'}}>
        <Header aboutActive={"active"}/>
        <SubNav2/>
        <ParallaxOtherPages
          parallaxOtherPages_bg={imgHome6}
          //parallaxOtherPages_title="Sobre nós."
          //parallaxOtherPages_desc="Design, Criativos e muito mais..."
          //parallaxOtherPages_txt="HS Design, uma das melhores gráficas de Luanda."
        />
        <br/>
        <br/>
        <br/>
        <TxtIntro1
           TxtIntro_title={"Conheça mais sobre a HS Design."}
           TxtIntro_description={"Saiba mais quem somos, o que fazemos e os nossos objectivos."}
        />
        <Section1/> 
        <Footer/>
      </div>
    </>
  );
}